import { render, staticRenderFns } from "./phone-number-select.vue?vue&type=template&id=65ebd2cc"
import script from "./phone-number-select.vue?vue&type=script&lang=js"
export * from "./phone-number-select.vue?vue&type=script&lang=js"
import style0 from "./phone-number-select.vue?vue&type=style&index=0&id=65ebd2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports